import * as THREE from 'three';
import GUI from 'lil-gui';
import { scene, group } from './Scene';
import { step, SetStep } from './ScenarioManager';
import { array } from 'three/tsl';

//#region common
export let idleMixer;
export let animations, mixer, obj;

const idleAnimationNums = [
    { index: 29 }, { index: 30 }, { index: 31 }, { index: 32 }, { index: 33 }, // 자판기
    { index: 34 }, // 회전판
    { index: 47 }, { index: 48 }, { index: 49 }, { index: 50 }, { index: 51 }, //
    { index: 52 }, { index: 53 }, { index: 54 }, { index: 55 }, { index: 56 },
    { index: 57 }, { index: 58 }, { index: 59 }, { index: 60 }, { index: 61 },
    { index: 62 }, { index: 63 }, { index: 64 }, { index: 65 }, { index: 66 }, // 깃발


    { index: 79 }, { index: 80 }, { index: 81 }, { index: 82 }, { index: 83 }, { index: 84 }, { index: 85 }, // 케이블카 

    // { index: 76 },
    { index: 89 }, // fan 
    { index: 90 }, { index: 91 }, // 08 line bot, top
];

const objetAnimationFrames = [
    { index: 0, startFrame: 94, endFrame: 173 }, // 0, 자판기에서 뽑힘
    { index: 1, startFrame: 174, endFrame: 249 }, // 1, 전구 회전
    { index: 2, startFrame: 174 }, // 2, 삼각뿔 빠짐
    { index: 3, startFrame: 250, endFrame: 265 }, // 3 전구 밑 대기
    { index: 4, startFrame: 250, endFrame: 265 }, // 4, 전구 밑 대기
    { index: 3, startFrame: 265, endFrame: 553 }, // 5, 기차
    { index: 4, startFrame: 265, endFrame: 553 }, // 6, 기차
    { index: 5, startFrame: 554, endFrame: 764 }, // 7, 열기구

    //todo 번호에 맞게 찾아주기
    { index: 10, startFrame: 1084, endFrame: 1145 }, // 8, 폭격 성공
    { index: 6, startFrame: 1084, endFrame: 1164 }, // 9, 폭격 실패
    { index: 7, startFrame: 1084, endFrame: 1164 }, // 10, 폭격 실패
    { index: 8, startFrame: 1084, endFrame: 1164 }, // 11, 폭격 실패
    { index: 9, startFrame: 1084, endFrame: 1164 }, // 12, 폭격 실패
    { index: 10, startFrame: 1146, endFrame: 1215 }, // 13, 폭격 성공

    { index: 12, startFrame: 1216, endFrame: 1724 }, // 14, 폭격 성공 후 이동
    { index: 13, startFrame: 1216, endFrame: 1724 }, // 15, 폭격 성공 후 이동

    { index: 14, startFrame: 1725, endFrame: 1860 }, // 16, 색칠하는 곳
    { index: 14, startFrame: 1914, endFrame: 2067 }, // 17, 회전해서 케이블카 바구니에 실림
    { index: 15, startFrame: 2068, endFrame: 2201 }, // 18, 케이블카 꼭대기 도착

    { index: 16, startFrame: 2264, endFrame: 2406 }, // 19, 패턴 기계에 진입
    { index: 17, startFrame: 2264, endFrame: 2406 }, // 20, 패턴 기계에 진입
    { index: 18, startFrame: 2468, endFrame: 2604 }, // 21, 패턴 기계에서 나와서 미끄럼틀로
    { index: 19, startFrame: 2468, endFrame: 2604 }, // 22, 패턴 기계에서 나와서 미끄럼틀로

    { index: 20, startFrame: 2674, endFrame: 3020 }, // 23, 미끄럼틀 다 미끌어짐
    { index: 21, startFrame: 3031, endFrame: 3070 }, // 24, 재생성
    { index: 22, startFrame: 3031, endFrame: 3078 }, // 25, 성공 
    { index: 23, startFrame: 3031, endFrame: 3092 }, // 26, 실패 뒤 넘어감
    { index: 24, startFrame: 3031, endFrame: 3083 }, // 27, 실패 날라감
    { index: 25, startFrame: 3031, endFrame: 3080 }, // 28, 실패 맞고 떨어짐
    { index: 26, startFrame: 3150, endFrame: 3215 }, // 29, 성공 후 등장
    { index: 26, startFrame: 3215, endFrame: 3300 }, // 30, 성공 후 등장 후 루핑
];

const stageAnimationFrames = [
    [], // 0
    [], // 1
    [], // 2
    [ // 3
        { index: 35, startFrame: 251, endFrame: 912 },
        { index: 36, startFrame: 251, endFrame: 912 },
        { index: 37, startFrame: 251, endFrame: 912 },
        { index: 38, startFrame: 251, endFrame: 912 },
    ],
    [ // 4
        { index: 39, startFrame: 554, endFrame: 795 },
        { index: 41, startFrame: 554, endFrame: 795 },
        { index: 42, startFrame: 554, endFrame: 795 },
        { index: 43, startFrame: 554, endFrame: 795 },
        { index: 44, startFrame: 554, endFrame: 795 },
        { index: 45, startFrame: 554, endFrame: 795 },
        // { index: 40, startFrame: 554, endFrame: 795 },
    ],
    [ // 5
        { index: 46, startFrame: 1084, endFrame: 1143 }
    ],
    [
        { index: 46, startFrame: 1144, endFrame: 1243 }
    ], // 6
    [   // 7
        // { index: 61, startFrame: 0, endFrame: 7 },
        // { index: 62, startFrame: 0, endFrame: 7 },
        // { index: 63, startFrame: 0, endFrame: 7 },
        // { index: 64, startFrame: 1862, endFrame: 1891 },
    ],
    [  // 8 케이블카
        { index: 79 },
        { index: 80 },
        { index: 81 },
        { index: 82 },
        { index: 83 },
        { index: 84 },
        { index: 85 },
    ],
    [  // 9 패턴기계
        // { index: 66, startFrame: 2468, endFrame: 2610 }
    ],
    [ // 10 미끄럼틀
        // {index: }
        { index: 27, startFrame: 2722, endFrame: 3020 },

        { index: 92, startFrame: 2722, endFrame: 2933 },
        { index: 93, startFrame: 2722, endFrame: 2933 },
        { index: 94, startFrame: 2722, endFrame: 2933 },
        { index: 95, startFrame: 2722, endFrame: 2933 },
        { index: 96, startFrame: 2722, endFrame: 2933 },
        { index: 97, startFrame: 2722, endFrame: 2933 },
        { index: 98, startFrame: 2722, endFrame: 2933 },

        { index: 99, startFrame: 2722, endFrame: 2933 },
        { index: 100, startFrame: 2722, endFrame: 2933 },
        { index: 101, startFrame: 2722, endFrame: 2933 },
        { index: 102, startFrame: 2722, endFrame: 2850 },// 손 문
        { index: 103, startFrame: 2722, endFrame: 2850 },// 손 문
        { index: 104, startFrame: 2722, endFrame: 2933 }, //레그 A 문
        { index: 105, startFrame: 2722, endFrame: 2933 },
        // 92 ~ 손 관련

        { index: 106, startFrame: 2722, endFrame: 2850 },
        { index: 107, startFrame: 2722, endFrame: 2850 },
        { index: 108, startFrame: 2722, endFrame: 2850 },
        { index: 109, startFrame: 2722, endFrame: 2850 },
        { index: 110, startFrame: 2722, endFrame: 2850 },
        { index: 111, startFrame: 2722, endFrame: 2850 },
        { index: 112, startFrame: 2722, endFrame: 2850 },
        { index: 113, startFrame: 2722, endFrame: 2850 },
        { index: 114, startFrame: 2722, endFrame: 2850 },
        { index: 115, startFrame: 2722, endFrame: 2850 },
        { index: 116, startFrame: 2722, endFrame: 2850 },
        { index: 117, startFrame: 2722, endFrame: 2850 },
        { index: 118, startFrame: 2722, endFrame: 2850 },
        { index: 119, startFrame: 2722, endFrame: 2850 },
        { index: 120, startFrame: 2722, endFrame: 2850 },
        { index: 121, startFrame: 2722, endFrame: 2850 },
        { index: 122, startFrame: 2722, endFrame: 2850 },
        { index: 123, startFrame: 2722, endFrame: 2850 },
        { index: 124, startFrame: 2722, endFrame: 2850 },
        { index: 125, startFrame: 2722, endFrame: 2850 },
        { index: 126, startFrame: 2722, endFrame: 2850 },
        { index: 127, startFrame: 2722, endFrame: 2850 },
        { index: 128, startFrame: 2722, endFrame: 2850 },
        { index: 129, startFrame: 2722, endFrame: 2850 },
        { index: 130, startFrame: 2722, endFrame: 2850 },
        { index: 131, startFrame: 2722, endFrame: 2850 },
        { index: 132, startFrame: 2722, endFrame: 2850 },
        { index: 133, startFrame: 2722, endFrame: 2850 },
        { index: 134, startFrame: 2722, endFrame: 2850 },
        { index: 135, startFrame: 2722, endFrame: 2850 },
        { index: 136, startFrame: 2722, endFrame: 2850 },
        { index: 137, startFrame: 2722, endFrame: 2850 },
        { index: 138, startFrame: 2722, endFrame: 2850 },
        { index: 139, startFrame: 2722, endFrame: 2850 },
        { index: 140, startFrame: 2722, endFrame: 2850 },
        { index: 141, startFrame: 2722, endFrame: 2850 },
        { index: 142, startFrame: 2722, endFrame: 2850 },
        { index: 143, startFrame: 2722, endFrame: 2850 },
        { index: 144, startFrame: 2722, endFrame: 2850 },
        { index: 145, startFrame: 2722, endFrame: 2850 },
        { index: 146, startFrame: 2722, endFrame: 2850 },
        { index: 147, startFrame: 2722, endFrame: 2850 },
        { index: 148, startFrame: 2722, endFrame: 2850 },
        { index: 149, startFrame: 2722, endFrame: 2850 },
        { index: 150, startFrame: 2722, endFrame: 2850 },
        { index: 151, startFrame: 2722, endFrame: 2850 },
        { index: 152, startFrame: 2722, endFrame: 2850 },
        { index: 153, startFrame: 2722, endFrame: 2850 },
        { index: 154, startFrame: 2722, endFrame: 2850 },
        { index: 155, startFrame: 2722, endFrame: 2850 },
        { index: 156, startFrame: 2722, endFrame: 2850 },
        { index: 157, startFrame: 2722, endFrame: 2850 },
    ],
    [ // 피날레
        { index: 102, startFrame: 3150, endFrame: 3298 },// 손 문
        { index: 103, startFrame: 3150, endFrame: 3298 },// 손 문
        { index: 106, startFrame: 3150, endFrame: 3298 },
        { index: 107, startFrame: 3150, endFrame: 3298 },
        { index: 108, startFrame: 3150, endFrame: 3298 },
        { index: 109, startFrame: 3150, endFrame: 3298 },
        { index: 110, startFrame: 3150, endFrame: 3298 },
        { index: 111, startFrame: 3150, endFrame: 3298 },
        { index: 112, startFrame: 3150, endFrame: 3298 },
        { index: 113, startFrame: 3150, endFrame: 3298 },
        { index: 114, startFrame: 3150, endFrame: 3298 },
        { index: 115, startFrame: 3150, endFrame: 3298 },
        { index: 116, startFrame: 3150, endFrame: 3298 },
        { index: 117, startFrame: 3150, endFrame: 3298 },
        { index: 118, startFrame: 3150, endFrame: 3298 },
        { index: 119, startFrame: 3150, endFrame: 3298 },
        { index: 120, startFrame: 3150, endFrame: 3298 },
        { index: 121, startFrame: 3150, endFrame: 3298 },
        { index: 122, startFrame: 3150, endFrame: 3298 },
        { index: 123, startFrame: 3150, endFrame: 3298 },
        { index: 124, startFrame: 3150, endFrame: 3298 },
        { index: 125, startFrame: 3150, endFrame: 3298 },
        { index: 126, startFrame: 3150, endFrame: 3298 },
        { index: 127, startFrame: 3150, endFrame: 3298 },
        { index: 128, startFrame: 3150, endFrame: 3298 },
        { index: 129, startFrame: 3150, endFrame: 3298 },
        { index: 130, startFrame: 3150, endFrame: 3298 },
        { index: 131, startFrame: 3150, endFrame: 3298 },
        { index: 132, startFrame: 3150, endFrame: 3298 },
        { index: 133, startFrame: 3150, endFrame: 3298 },
        { index: 134, startFrame: 3150, endFrame: 3298 },
        { index: 135, startFrame: 3150, endFrame: 3298 },
        { index: 136, startFrame: 3150, endFrame: 3298 },
        { index: 137, startFrame: 3150, endFrame: 3298 },
        { index: 138, startFrame: 3150, endFrame: 3298 },
        { index: 139, startFrame: 3150, endFrame: 3298 },
        { index: 140, startFrame: 3150, endFrame: 3298 },
        { index: 141, startFrame: 3150, endFrame: 3298 },
        { index: 142, startFrame: 3150, endFrame: 3298 },
        { index: 143, startFrame: 3150, endFrame: 3298 },
        { index: 144, startFrame: 3150, endFrame: 3298 },
        { index: 145, startFrame: 3150, endFrame: 3298 },
        { index: 146, startFrame: 3150, endFrame: 3298 },
        { index: 147, startFrame: 3150, endFrame: 3298 },
        { index: 148, startFrame: 3150, endFrame: 3298 },
        { index: 149, startFrame: 3150, endFrame: 3298 },
        { index: 150, startFrame: 3150, endFrame: 3298 },
        { index: 151, startFrame: 3150, endFrame: 3298 },
        { index: 152, startFrame: 3150, endFrame: 3298 },
        { index: 153, startFrame: 3150, endFrame: 3298 },
        { index: 154, startFrame: 3150, endFrame: 3298 },
        { index: 155, startFrame: 3150, endFrame: 3298 },
        { index: 156, startFrame: 3150, endFrame: 3298 },
        { index: 157, startFrame: 3150, endFrame: 3298 },
    ]
]

export const camPartAnimations = {
    cam: [],
    aim: []
};

const camSplitFrames = [
    [0, 39],
    [76, 210],
    [250, 484],
    [633, 738],
    [739, 1083],
    [1084, 1144],
    [1145, 1724],
    [1725, 1842],
    [1923, 2375],
    [2461, 2610],
    [2611, 2900],
    [3104, 3147]
]

//#endregion

//#region init
export const SetAnimations = (_gltf, _obj) => {
    animations = _gltf.animations;
    obj = _obj;

    //! TEST
    // console.log("Animations: ", animations);

    mixer = new THREE.AnimationMixer(_obj);
    idleMixer = new THREE.AnimationMixer(_obj);

    const clock = new THREE.Clock();

    //#region GUI TEST
    // const gui = new GUI();
    // let animationControls = {};
    // let animationGroups = {}; // ✅ 그룹별 폴더 저장

    // // ✅ 애니메이션 그룹 매핑
    // const animationGroupsMapping = {
    //     geo: Array.from({ length: 27 }, (_, i) => i),
    //     train: Array.from({ length: 4 }, (_, i) => i + 35),
    //     slide: Array.from({ length: 14 }, (_, i) => i + 92),
    //     hand: Array.from({ length: 45 }, (_, i) => i + 106),
    //     cam: [153, 154],
    //     other: Array.from({ length: 157 }, (_, i) => i),
    // };


    // // ✅ 그룹별 컨트롤 패널 추가
    // Object.keys(animationGroupsMapping).forEach(groupName => {
    //     animationGroups[groupName] = gui.addFolder(groupName);
    // });

    // // ✅ 그룹별 컨트롤러 추가
    // const groupControls = {};
    // Object.keys(animationGroupsMapping).forEach(groupName => {
    //     const maxDuration = Math.max(...animationGroupsMapping[groupName].map(index =>
    //         animations[index] ? animations[index].duration : 0
    //     )) || 1.0;
    //     groupControls[groupName] = {
    //         play: () => PlayAnimationGroup(groupName),
    //         stop: () => StopAnimationGroup(groupName),
    //         speed: 1.0,
    //         duration: maxDuration,
    //         currentFrame: 0,
    //         targetFrame: Math.round(maxDuration * 30),
    //         setFrame: () => SetAnimationFrame(groupName, groupControls[groupName].targetFrame)
    //     };

    //     const folder = animationGroups[groupName];
    //     folder.add(groupControls[groupName], 'play').name(`▶ Play ${groupName}`);
    //     folder.add(groupControls[groupName], 'stop').name(`⏹ Stop ${groupName}`);
    //     folder.add(groupControls[groupName], 'speed', 0.1, 3.0, 0.1).name("Speed").onChange((value) => {
    //         SetAnimationSpeed(groupName, value);
    //     });
    //     folder.add(groupControls[groupName], 'duration', maxDuration).name("Duration").onChange(value => {
    //         groupControls[groupName].targetFrame = Math.round(value * 30);
    //         SetAnimationFrame(groupName, groupControls[groupName].targetFrame);
    //     });
    //     folder.add(groupControls[groupName], 'currentFrame', 0, Math.round(maxDuration * 30), 1).name("Current Frame").listen();
    //     folder.add(groupControls[groupName], 'targetFrame', 0, Math.round(maxDuration * 30), 1).name("Target Frame").onChange(value => {
    //         SetAnimationFrame(groupName, value);
    //     });
    //     folder.add(groupControls[groupName], 'setFrame').name("⏸ Set Frame");
    // });

    // // ✅ 그룹 애니메이션 실행 함수
    // const PlayAnimationGroup = (groupName) => {
    //     const indices = animationGroupsMapping[groupName];
    //     if (!indices) return;

    //     indices.forEach(index => {
    //         const action = mixer.clipAction(animations[index]);
    //         action.reset();
    //         action.setLoop(THREE.LoopOnce);
    //         action.clampWhenFinished = true;
    //         action.setEffectiveTimeScale(groupControls[groupName].speed);
    //         action.play();
    //     });
    // };

    // // ✅ 그룹 애니메이션 정지 함수
    // const StopAnimationGroup = (groupName) => {
    //     animationGroupsMapping[groupName].forEach(index => {
    //         mixer.clipAction(animations[index]).stop();
    //     });
    // };

    // // ✅ 그룹 애니메이션 속도 조절
    // const SetAnimationSpeed = (groupName, speed) => {
    //     animationGroupsMapping[groupName].forEach(index => {
    //         mixer.clipAction(animations[index]).setEffectiveTimeScale(speed);
    //     });
    // };

    // // ✅ 특정 프레임으로 이동
    // const SetAnimationFrame = (groupName, targetFrame) => {
    //     const frameRate = 30;
    //     const targetTime = targetFrame / frameRate;
    //     animationGroupsMapping[groupName].forEach(index => {
    //         const action = mixer.clipAction(animations[index]);
    //         action.time = targetTime;
    //         mixer.update(0);
    //     });
    // };


    // // ✅ 모든 애니메이션 추가
    // animations.forEach((clip, index) => {
    //     const action = mixer.clipAction(clip);
    //     const durationInFrames = Math.round(clip.duration * 30); // 30fps 기준

    //     const updateCurrentFrame = () => {
    //         requestAnimationFrame(updateCurrentFrame);
    //         const delta = clock.getDelta();
    //         mixer.update(delta);
    //         animationControls[clip.name].currentFrame = Math.round(action.time * 30);
    //     };

    //     animationControls[clip.name] = {
    //         play: () => {
    //             action.play();
    //             action.setEffectiveTimeScale(animationControls[clip.name].speed);
    //             updateCurrentFrame();
    //         },
    //         stop: () => action.stop(),
    //         speed: 1.0,
    //         currentFrame: 0,
    //         targetFrame: 0,
    //         setFrame: () => {
    //             const targetTime = animationControls[clip.name].targetFrame / 30;
    //             action.paused = true;
    //             action.time = targetTime;
    //             mixer.update(0);
    //         }
    //     };


    //     // ✅ 기존처럼 애니메이션을 그룹으로 나누기
    //     const groupName = Object.keys(animationGroupsMapping).find(key =>
    //         animationGroupsMapping[key].includes(index)
    //     );

    //     if (groupName) {
    //         if (groupName === 'geo' || groupName === 'other') {
    //             const folder = animationGroups[groupName];

    //             folder.add(animationControls[clip.name], 'play').name(`▶ Play ${clip.name}`);
    //             folder.add(animationControls[clip.name], 'stop').name(`⏹ Stop ${clip.name}`);
    //             folder.add(animationControls[clip.name], 'speed', 0.1, 3.0, 0.1).name("Speed").onChange((value) => {
    //                 action.setEffectiveTimeScale(value);
    //             });
    //             folder.add(animationControls[clip.name], 'currentFrame', 0, durationInFrames, 1)
    //                 .name("Current Frame")
    //                 .listen();
    //             folder.add(animationControls[clip.name], 'targetFrame', 0, durationInFrames, 1)
    //                 .name("Target Frame")
    //                 .onChange(() => {
    //                     const targetTime = animationControls[clip.name].targetFrame / 30;
    //                     action.paused = true;
    //                     action.time = targetTime;
    //                     mixer.update(0);
    //                 });
    //             folder.add(animationControls[clip.name], 'setFrame').name("⏸ Set Frame");
    //         }
    //         // For groups 'slide', 'hand', and 'cam', group-level controls will be added later.
    //     }
    // });

    // // ✅ 기본적으로 그룹 패널 열기
    // Object.values(animationGroups).forEach(folder => folder.open());

    //#endregion

    camPartAnimations.cam = SplitAnimation(160, camSplitFrames);
    camPartAnimations.aim = SplitAnimation(161, camSplitFrames);

    // console.log(camPartAnimations);

    // const guiFolder = gui.addFolder("Split Animations");

    // for (let i = 0; i < camPartAnimations.cam.length; i++) {
    //     guiFolder.add({
    //         [`playPart${i}`]: () => {
    //             StopCameraAction();
    //             PlayCameraAction(i);
    //         }
    //     }, `playPart${i}`).name(`▶ Play Part ${i}`);
    //     guiFolder.add({
    //         [`rewindPart${i}`]: () => {
    //             RewindAction(camPartAnimations.cam[i]);
    //             RewindAction(camPartAnimations.aim[i]);
    //         }
    //     }, `rewindPart${i}`).name(`▶ Rewind Part ${i}`);
    // }

    StartIdleAnimation(idleAnimationNums);
};

// const getAvailableMixer = (_obj) => {
//     let availableMixer = mixers.find(mixer => mixer._actions.length === 0);
//     if (!availableMixer) {
//         availableMixer = new THREE.AnimationMixer(_obj);
//         mixers.push(availableMixer);
//     }
//     return availableMixer;
// }
//#endregion

//#region animation events
export const AnimationMouseEvents = {
    mouseDown: (_downObject) => {
        if (_downObject.name === 'start_coin') {
            PlayCameraAction(0);
        }
        else if (_downObject.name === 's01_button')
            PlayAnimation({ index: 28 });

        if (step === 10) {
            if (_downObject.name === 's07_blue_pump' || _downObject.name === 's07_blue_cap')
                PlayAnimation([{ index: 71 }, { index: 72 }], null, 2);
            else if (_downObject.name === 's07_green_pump' || _downObject.name === 's07_green_cap')
                PlayAnimation([{ index: 73 }, { index: 74 }], null, 2);
            else if (_downObject.name === 's07_red_pump' || _downObject.name === 's07_red_cap')
                PlayAnimation([{ index: 75 }, { index: 76 }], null, 2);
        }
        if (step === 13) {
            if (_downObject.name === 's09_button_top')
                PlayAnimation({ index: 88 })
            else if (_downObject.name === 's09_button_bot')
                PlayAnimation({ index: 86 })
            else if (_downObject.name === 's09_button_enter')
                PlayAnimation({ index: 87 })
        }
    },
    mouseHover: (_hoverObject) => {
        // if (_hoverObject.name === 's07_lever')
        //     if (step === 9)
        //         PlayAnimation({ index: 64, startFrame: 1862, endFrame: 1891 });
    },
    mouseDrag: (object) => {

    },
    mouseDrop: (_upObject, _downObject) => {
        if (_upObject.name == 's01_hitbox' && _downObject.name == 'start_coin') {
            //todo play coin animations
            const coin = scene.getObjectByName('start_coin');
            const coinAni = scene.getObjectByName('start_coin_ani');

            coin.visible = false;
            coinAni.visible = true;
            PlayAnimation({ index: 163 });
        }
    },
    mouseClick: (_clickedObject) => {

    },
    mouseUp: (_upObject) => {
        //todo animation stop(?) or return to idle
        if (step === 0)
            if (_upObject.name === 'start_coin') {
                // StopCameraAction();
                RewindCameraAction(0);
            }
        if (_upObject.name === 's01_button')
            RewindAnimation({ index: 28 });
        if (step === 10) {
            if (_upObject.name === 's07_blue_pump' || _upObject.name === 's07_blue_cap')
                RewindAnimation([{ index: 71 }, { index: 72 }], null, 2);
            else if (_upObject.name === 's07_green_pump' || _upObject.name === 's07_green_cap')
                RewindAnimation([{ index: 73 }, { index: 74 }], null, 2);
            else if (_upObject.name === 's07_red_pump' || _upObject.name === 's07_red_cap')
                RewindAnimation([{ index: 75 }, { index: 76 }], null, 2);
        }
        if (step === 13) {
            if (_upObject.name === 's09_button_top')
                RewindAnimation({ index: 88 })
            else if (_upObject.name === 's09_button_bot')
                RewindAnimation({ index: 86 })
            else if (_upObject.name === 's09_button_enter')
                RewindAnimation({ index: 87 })
        }
    }
}
//#endregion

//#region play functions

// 예제: "bezier_body"의 "Smile" 블렌드 쉐이프 값을 0.8로 설정
// setBlendShape("bezier_body", "Smile", 0.8);

export const PlayObjetAnimation = (_index, _onComplete = null, _timeScale = 1, _loopType = THREE.LoopOnce) => {
    PlayAnimation(objetAnimationFrames[_index], _onComplete, _timeScale, _loopType);
}

export const PlayStageAnimation = (_index, _onComplete = null, _timeScale = 1, _loopType = THREE.LoopOnce) => {
    PlayAnimation(stageAnimationFrames[_index], _onComplete, _timeScale, _loopType);
}

// ✅ idle 애니메이션 실행 (전용 mixer 사용)
const StartIdleAnimation = (animationData) => {
    if (!animations.length) {
        console.warn("⚠️ Animations이 설정되지 않았습니다.");
        return;
    }

    animationData.forEach(({ index }) => {
        if (animations[index]) {
            const action = idleMixer.clipAction(animations[index]);
            action.setLoop(THREE.LoopRepeat);
            action.clampWhenFinished = false;
            action.stop();
            action.play();
        }
    });
};

export const StopIdleAnimation = (animationData) => {
    if (!animations.length) {
        console.warn("⚠️ Animations이 설정되지 않았습니다.");
        return;
    }
    animationData.forEach(({ index }) => {
        if (animations[index]) {
            const action = idleMixer.clipAction(animations[index]);
            action.setLoop(THREE.LoopOnce);
            action.clampWhenFinished = true;
        }
    });
}
export const ReplayIdleAnimation = (animationData) => {
    if (!animations.length) {
        console.warn("⚠️ Animations이 설정되지 않았습니다.");
        return;
    }

    animationData.forEach(({ index }) => {
        if (animations[index]) {
            const action = idleMixer.clipAction(animations[index]);
            action.stop();
            action.setLoop(THREE.LoopRepeat);
            action.clampWhenFinished = false;
            action.play();
        }
    });
}
const animationFrameMap = new Map(); // index별 animationFrame ID 저장
// ✅ 특정 애니메이션 실행
export const PlayAnimation = (animationData, onComplete = null, timeScale = 1, loopType = THREE.LoopOnce) => {
    if (!mixer || animations.length === 0) {
        console.warn("⚠️ Animations 또는 Mixer가 설정되지 않았습니다.");
        return;
    }
    const animationsArray = Array.isArray(animationData) ? animationData : [animationData];

    animationsArray.forEach(({ index, startFrame = 0, endFrame }) => {
        if (!endFrame && animations[index]) {
            endFrame = Math.round(animations[index].duration * 30); // 전체 길이
        }
        const frameRate = 30; // 30fps 기준
        const startTime = startFrame / frameRate;
        const endTime = endFrame / frameRate;

        if (animations[index]) {
            // const mixer = getAvailableMixer(obj);
            const action = mixer.clipAction(animations[index]);

            action.stop();
            action.timeScale = timeScale;
            if (loopType === THREE.LoopPingPong)
                action.setLoop(loopType, 4);
            else if (loopType === THREE.LoopRepeat)
                action.setLoop(loopType);
            else
                action.setLoop(loopType, 1);
            action.clampWhenFinished = true;
            action.time = startTime;
            mixer.update(0);
            action.play();

            let isReversing = false;

            const updateAnimation = () => {
                if (loopType === THREE.LoopPingPong) {
                    if (action.time >= endTime) {
                        isReversing = true;
                    } else if (action.time <= startTime) {
                        isReversing = false;
                    }
                }

                if (!isReversing && action.time >= endTime) {
                    // action.stop();
                    // action.stop();
                    if (loopType === THREE.LoopRepeat) {
                        action.time = startTime;
                        mixer.update(0);
                        requestAnimationFrame(updateAnimation);
                    }
                    else {

                        action.paused = true;
                        action.time = endTime;
                        mixer.update(0);
                        mixer.uncacheAction(action);
                    }

                    // // ✅ mixer에 할당된 애니메이션 제거
                    // const mixerIndex = mixers.indexOf(mixer);
                    // if (mixerIndex !== -1) {
                    //     mixers[mixerIndex]._actions = mixers[mixerIndex]._actions.filter(a => a !== action);
                    // }
                    // console.log(index, 'animation is complete !')
                    if (onComplete && loopType !== THREE.LoopRepeat) onComplete();
                } else {
                    requestAnimationFrame(updateAnimation);
                }
            };
            requestAnimationFrame(updateAnimation);

        } else {
            console.warn(`⚠️ 애니메이션 '${index}'을 찾을 수 없습니다.`);
        }
    });
};

// ✅ 특정 애니메이션 되감기
export const RewindAnimation = (animationData, onComplete = null, timeScale = 1) => {
    if (!mixer || animations.length === 0) {
        console.warn("⚠️ Animations 또는 Mixer가 설정되지 않았습니다.");
        return;
    }
    const animationsArray = Array.isArray(animationData) ? animationData : [animationData];

    animationsArray.forEach(({ index, startFrame = 0, endFrame }) => {
        if (!endFrame && animations[index]) {
            endFrame = Math.round(animations[index].duration * 30); // 전체 길이
        }
        const frameRate = 30; // 30fps 기준
        const startTime = startFrame / frameRate;
        const endTime = endFrame / frameRate;

        const action = mixer.clipAction(animations[index]);

        if (action) {
            action.paused = false;
            // action.timeScale = -1; // 역재생
            action.timeScale = -timeScale;
            action.play();
        }

        const updateAnimation = () => {
            if (action.time <= startTime) {
                action.paused = true;
                action.time = startTime;
                mixer.update(0);
                mixer.uncacheAction(action);

                // // ✅ mixer에 할당된 애니메이션 제거
                // const mixerIndex = mixers.indexOf(mixer);
                // if (mixerIndex !== -1) {
                //     mixers[mixerIndex]._actions = mixers[mixerIndex]._actions.filter(a => a !== action);
                // }
                // console.log('animation is Rewind complete !')
                if (onComplete)
                    onComplete();
            } else {
                requestAnimationFrame(updateAnimation);
            }
        };
        requestAnimationFrame(updateAnimation);
    });
};

export const StopAnimation = (animationData) => {
    if (!animations.length) {
        console.warn("⚠️ Animations이 설정되지 않았습니다.");
        return;
    }
    animationData.forEach(({ index }) => {
        if (animations[index]) {
            const action = mixer.clipAction(animations[index]);
            action.paused = true;
        }
    });
}

export const PlayCameraAction = (_index, _timeScale = 1) => {
    const newCamAction = camPartAnimations.cam[_index];
    const newAimAction = camPartAnimations.aim[_index];

    PlayAction(newCamAction, _timeScale);
    PlayAction(newAimAction, _timeScale);
}

export const RewindCameraAction = (_index, _timeScale = 1) => {
    const newCamAction = camPartAnimations.cam[_index];
    const newAimAction = camPartAnimations.aim[_index];

    RewindAction(newCamAction, _timeScale);
    RewindAction(newAimAction, _timeScale);
}

export const StopCameraAction = () => {
    for (var i = 0; i < camPartAnimations.cam.length; i++) {
        camPartAnimations.cam[i].reset();
        camPartAnimations.cam[i].stop();
        camPartAnimations.aim[i].reset();
        camPartAnimations.aim[i].stop();
    }
}

const PlayAction = (action, timeScale = 1) => {
    action.reset();
    action.stop();
    action.timeScale = timeScale;
    action.setLoop(THREE.LoopOnce);
    action.clampWhenFinished = true;
    action.play();
}

const RewindAction = (action, timeScale = 1) => {
    action.paused = false;
    action.timeScale = -timeScale; // 역재생 (되감기)
    action.play();
}

//#endregion

//#region frame function
export const SetFrameAnimation = (animationData) => {
    if (!mixer || animations.length === 0) {
        console.warn("⚠️ Animations 또는 Mixer가 설정되지 않았습니다.");
        return;
    }
    const animationsArray = Array.isArray(animationData) ? animationData : [animationData];

    animationsArray.forEach(({ index, frame = 0 }) => {
        const frameRate = 30; // 30fps 기준
        const time = frame / frameRate;

        if (animations[index]) {
            // const mixer = getAvailableMixer(obj);
            const action = mixer.clipAction(animations[index]);
            // action.reset();
            action.clampWhenFinished = true;
            action.time = time;
            action.paused = true;
            mixer.update(0);

        } else {
            console.warn(`⚠️ 애니메이션 '${index}'을 찾을 수 없습니다.`);
        }
    });
}
//#endregion

//#region common

const SplitAnimation = (index, splitFrames) => {
    if (!mixer || animations.length === 0 || !animations[index]) {
        console.warn("⚠️ Animations 또는 Mixer가 설정되지 않았습니다.");
        return;
    }

    const originalClip = animations[index];
    const frameRate = 30; // 30fps 기준
    let newActions = [];

    splitFrames.forEach((frames, i) => {
        const startTime = frames[0] / frameRate; // 초 단위 변환
        const endTime = frames[1] / frameRate;
        const duration = endTime - startTime;

        if (duration <= 0) {
            console.warn(`⚠️ 잘못된 프레임 범위: ${frames}`);
            return;
        }

        // 새로운 애니메이션 클립 생성 (시간 범위 지정)
        const newClip = THREE.AnimationUtils.subclip(originalClip, `${originalClip.name}_part${i}`, frames[0], frames[1], frameRate);
        const newAction = mixer.clipAction(newClip);

        newAction.loop = THREE.LoopOnce;
        newAction.clampWhenFinished = true;
        newAction.paused = true; // 기본적으로 정지된 상태
        newActions.push(newAction);
    });

    // console.log(`✅ ${originalClip.name}이 ${newActions.length}개의 파트로 분할됨!`);
    return newActions;
};

export const UpdateMixers = (deltaTime) => {
    // mixers.forEach(mixer => mixer.update(deltaTime));
    mixer.update(deltaTime);
    idleMixer.update(deltaTime); // ✅ idleMixer도 업데이트
};
//#endregion